var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3309 14.8675C13.5241 15.0043 13.7731 15.0385 13.9951 14.9545C14.2171 14.8699 14.3803 14.6803 14.4295 14.4505C14.9509 12.0001 16.2157 5.79789 16.6903 3.56889C16.7263 3.40089 16.6663 3.22629 16.5343 3.11409C16.4023 3.00189 16.2193 2.96949 16.0561 3.03009C13.5403 3.96129 5.79254 6.86829 2.62573 8.04009C2.42473 8.11449 2.29393 8.30769 2.30053 8.5195C2.30773 8.7319 2.45053 8.9161 2.65633 8.9779C4.07653 9.4027 5.94074 9.9937 5.94074 9.9937C5.94074 9.9937 6.81194 12.6247 7.26614 13.9627C7.32314 14.1307 7.45454 14.2627 7.62794 14.3083C7.80074 14.3533 7.98554 14.3059 8.11454 14.1841C8.84414 13.4953 9.97214 12.4303 9.97214 12.4303C9.97214 12.4303 12.1153 14.0017 13.3309 14.8675ZM6.72494 9.6613L7.73234 12.9841L7.95614 10.8799C7.95614 10.8799 11.8483 7.36929 14.0671 5.36829C14.1319 5.30949 14.1409 5.21109 14.0869 5.14209C14.0335 5.07309 13.9351 5.05689 13.8613 5.10369C11.2897 6.74589 6.72494 9.6613 6.72494 9.6613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e1aed7143dd8ed39dc2743520822923f.svg";
export { ForwardRef as ReactComponent };